<template>
    <v-container fluid class="alteracao-horario-manual">
      <!-- Cabeçalho -->
      <v-row>
        <v-col cols="12">
          <v-card class="mb-4" elevation="2">
            <v-card-title class="d-flex align-center pa-4 white--text" 
                          style="background: linear-gradient(135deg, #2196F3 0%, #21CBF3 100%);">
              <v-icon left color="white" size="32">mdi-clock-edit-outline</v-icon>
              <div>
                <div class="text-h5 font-weight-bold">Alteração Manual de Horários</div>
                <div class="text-subtitle-2 mt-1">Ajuste horários de expedientes (abertos, fechados ou encerrados)</div>
              </div>
              <v-spacer></v-spacer>
              <v-btn icon color="white" @click="mostrarAjuda = true" class="mr-2">
                <v-icon>mdi-help-circle</v-icon>
              </v-btn>
              <v-btn icon color="white" @click="voltarMenu">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
  
      <!-- Filtros de Busca -->
      <v-row>
        <v-col cols="12">
          <v-card class="mb-4" elevation="1">
            <v-card-title class="d-flex align-center">
              <v-icon left color="primary">mdi-filter</v-icon>
              <span>Filtros de Busca</span>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="buscarRegistros" :loading="loadingBusca">
                <v-icon left>mdi-magnify</v-icon>
                Buscar
              </v-btn>
            </v-card-title>
  
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="3">
                  <v-text-field v-model="filtros.id_abertura" label="ID Abertura" type="number"
                                variant="outlined" density="compact" clearable
                                hint="Opcional - Filtrar por abertura específica"></v-text-field>
                </v-col>
  
                <v-col cols="12" md="3">
                  <v-autocomplete 
                    v-model="filtros.id_funcionario" 
                    :items="funcionariosUnicos" 
                    item-title="nome"
                    item-value="id"
                    label="Funcionário" 
                    variant="outlined" 
                    density="compact" 
                    clearable
                    hint="Selecione um funcionário"
                  ></v-autocomplete>
                </v-col>
  
                <v-col cols="12" md="3">
                  <v-select v-model="filtros.status" :items="statusDisponiveis" item-title="descricao"
                            item-value="valor" label="Status" variant="outlined" density="compact" clearable
                            hint="Filtrar por status" :loading="loadingStatus"></v-select>
                </v-col>
  
                <v-col cols="12" md="2">
                  <v-checkbox v-model="filtros.incluirFechados" label="Incluir fechados" density="comfortable"
                              hint="Mostrar registros já fechados"></v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox v-model="filtros.agruparPorStatus" label="Agrupar por status" density="comfortable"
                              hint="Mostrar em grupos"></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
  
      <!-- Resumo e Estatísticas -->
      <v-row v-if="totais.registros">
        <v-col cols="12" md="3">
          <v-card color="info" theme="dark">
            <v-card-text class="text-center pa-3">
              <v-icon size="36" class="mb-2">mdi-clock</v-icon>
              <div class="text-h5 font-weight-bold">{{ totais.registros }}</div>
              <div class="text-caption">Registros</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card color="primary" theme="dark">
            <v-card-text class="text-center pa-3">
              <v-icon size="36" class="mb-2">mdi-clock-check</v-icon>
              <div class="text-h5 font-weight-bold">{{ totais.abertos || 0 }}</div>
              <div class="text-caption">Em aberto</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card color="warning" theme="dark">
            <v-card-text class="text-center pa-3">
              <v-icon size="36" class="mb-2">mdi-clock-edit</v-icon>
              <div class="text-h5 font-weight-bold">{{ totais.fechados || 0 }}</div>
              <div class="text-caption">Fechados</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card color="success" theme="dark">
            <v-card-text class="text-center pa-3">
              <v-icon size="36" class="mb-2">mdi-clock-alert</v-icon>
              <div class="text-h5 font-weight-bold">{{ totais.encerrados || 0 }}</div>
              <div class="text-caption">Encerrados</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
  
      <!-- Lista de Registros -->
      <v-row>
        <v-col cols="12">
          <v-card elevation="2">
            <v-card-title class="d-flex align-center py-4">
              <v-icon left color="primary">mdi-account-clock</v-icon>
              <span class="text-h6">Registros para Ajuste</span>
              <v-spacer></v-spacer>
              <v-chip color="primary" variant="outlined" class="mr-2">
                <v-icon start>mdi-account-multiple</v-icon>
                {{ registros.length }} registro(s)
              </v-chip>
            </v-card-title>
  
            <v-card-text>
              <!-- Loading -->
              <div v-if="loadingBusca" class="text-center py-8">
                <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                <div class="mt-4 text-h6">Buscando registros...</div>
              </div>
  
              <!-- Sem dados -->
              <div v-else-if="registros.length === 0" class="text-center py-8">
                <v-icon size="64" color="grey lighten-1">mdi-clock-alert-outline</v-icon>
                <div class="mt-4 text-h6 grey--text">Nenhum registro encontrado</div>
                <div class="text-body-2 grey--text">
                  Ajuste os filtros e tente novamente
                </div>
              </div>
  
              <!-- 📅 VISUALIZAÇÃO EM TIMELINE (Agrupado) -->
              <div v-else-if="filtros.agruparPorStatus && registrosAgrupados.length > 0" class="timeline-container pa-4">
                <v-timeline side="end" align="start" truncate-line="both">
                  <v-timeline-item
                    v-for="(grupo, index) in registrosAgrupados"
                    :key="index"
                    :dot-color="index === 0 ? 'success' : (index === registrosAgrupados.length - 1 ? 'error' : 'primary')"
                    size="large"
                  >
                    <!-- Horário no lado esquerdo -->
                    <template v-slot:opposite>
                      <div class="timeline-time">
                        <div class="text-h6 font-weight-bold text-primary">
                          {{ grupo.horario_abertura }}
                        </div>
                        <v-icon size="20" color="grey">mdi-arrow-down</v-icon>
                        <div class="text-h6 font-weight-bold text-warning">
                          {{ grupo.horario_fechamento }}
                        </div>
                        <div class="text-caption text-grey mt-1">
                          ⏱️ {{ grupo.tempo_total }}
                        </div>
                      </div>
                    </template>

                    <!-- Conteúdo principal ao lado direito -->
                    <v-card elevation="3" class="timeline-card">
                      <v-card-title class="pa-3" style="background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);">
                        <div class="d-flex align-center w-100">
                          <div class="flex-grow-1">
                            <div class="text-subtitle-1 font-weight-bold">
                              {{ grupo.status_inicio }} → {{ grupo.status_fim }}
                            </div>
                            <div class="d-flex gap-2 flex-wrap mt-1">
                              <v-chip size="x-small" color="info" variant="flat">
                                <v-icon left size="12">mdi-account-multiple</v-icon>
                                {{ grupo.total }}
                              </v-chip>
                              <v-chip 
                                v-if="grupo.total_com_motivo > 0"
                                size="x-small" 
                                color="orange" 
                                variant="flat"
                              >
                                <v-icon left size="12">mdi-alert-circle</v-icon>
                                {{ grupo.total_com_motivo }} com motivo
                              </v-chip>
                            </div>
                          </div>
                          <div class="d-flex gap-2">
                            <v-btn
                              color="primary"
                              variant="text"
                              size="small"
                              @click="selecionarGrupo(grupo)"
                              icon
                            >
                              <v-icon>mdi-checkbox-multiple-marked</v-icon>
                              <v-tooltip activator="parent" location="top">Selecionar Todos</v-tooltip>
                            </v-btn>
                            <v-btn
                              color="success"
                              size="small"
                              @click="alterarGrupo(grupo)"
                              :disabled="!verificarGrupoSelecionado(grupo)"
                            >
                              <v-icon left size="16">mdi-clock-edit</v-icon>
                              Alterar ({{ contarSelecionadosGrupo(grupo) }})
                            </v-btn>
                          </div>
                        </div>
                      </v-card-title>

                      <!-- Lista compacta de funcionários -->
                      <v-card-text class="pa-0">
                        <v-expansion-panels flat>
                          <v-expansion-panel>
                            <v-expansion-panel-title class="py-2">
                              <v-icon left size="18">mdi-account-group</v-icon>
                              <span class="text-body-2">Funcionários ({{ grupo.total }})</span>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                              <v-list density="compact" class="pa-0">
                                <v-list-item
                                  v-for="registro in grupo.registros"
                                  :key="registro.id"
                                  class="px-2"
                                >
                                  <template v-slot:prepend>
                                    <v-checkbox
                                      :model-value="registrosSelecionados.includes(registro)"
                                      @update:model-value="toggleRegistro(registro)"
                                      hide-details
                                      density="compact"
                                    ></v-checkbox>
                                  </template>
                                  
                                  <v-list-item-title class="text-body-2">
                                    {{ registro.funcionario_nome }}
                                  </v-list-item-title>
                                  
                                  <v-list-item-subtitle>
                                    <div class="text-caption">
                                      OP: #{{ registro.ordem_numero }} | {{ registro.tempo_formatado }}
                                    </div>
                                    
                                    <!-- Motivo destacado -->
                                    <v-alert
                                      v-if="registro.motivo || registro.motivo_ajuste"
                                      density="compact"
                                      type="warning"
                                      variant="tonal"
                                      class="mt-2 text-caption"
                                    >
                                      <template v-slot:prepend>
                                        <v-icon size="14">mdi-alert-circle</v-icon>
                                      </template>
                                      <strong>Motivo:</strong> {{ registro.motivo || registro.motivo_ajuste }}
                                    </v-alert>
                                  </v-list-item-subtitle>

                                  <template v-slot:append>
                                    <v-chip 
                                      size="x-small" 
                                      :color="getCorStatus(registro.status)"
                                      variant="flat"
                                    >
                                      {{ registro.status }}
                                    </v-chip>
                                  </template>
                                </v-list-item>
                              </v-list>
                            </v-expansion-panel-text>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </div>

              <!-- Tabela de Registros (Não agrupado) -->
              <v-data-table
                v-else
                v-model="registrosSelecionados"
                :headers="headers"
                :items="registros"
                item-value="id"
                show-select
                class="elevation-1"
                density="compact"
              >
                <!-- Coluna ID Abertura -->
                <template #item.id_abertura="{ item }">
                  <v-chip size="small" color="primary" variant="outlined">
                    {{ item.id_abertura }}
                  </v-chip>
                </template>

                <!-- Coluna Lote -->
                <template #item.lote_processamento="{ item }">
                  <v-chip v-if="item.lote_processamento" 
                          size="small" 
                          color="secondary" 
                          variant="tonal">
                    {{ item.lote_processamento.substring(0, 8) }}...
                    <v-tooltip activator="parent" location="top">
                      <div><strong>Lote Completo:</strong></div>
                      <div class="text-caption">{{ item.lote_processamento }}</div>
                      <div class="mt-2 text-caption text-grey">
                        Clique em "Buscar" para agrupar por lote
                      </div>
                    </v-tooltip>
                  </v-chip>
                  <span v-else class="text-caption text-grey">Sem lote</span>
                </template>

                <!-- Coluna Funcionário -->
                <template #item.funcionario_nome="{ item }">
                  <div class="text-body-2 font-weight-medium">
                    {{ item.funcionario_nome }}
                    <v-tooltip activator="parent" location="top">
                      <div><strong>Cargo:</strong> {{ item.cargo_nome || 'N/A' }}</div>
                      <div><strong>Setor:</strong> {{ item.setor_nome }}</div>
                      <div class="text-caption mt-1">ID: {{ item.id_funcionario }}</div>
                    </v-tooltip>
                  </div>
                </template>

                <!-- Coluna Ordem -->
                <template #item.ordem_numero="{ item }">
                  <v-chip v-if="item.ordem_numero && item.ordem_numero !== 'N/A'" 
                          size="small" color="info" variant="tonal">
                    #{{ item.ordem_numero }}
                  </v-chip>
                  <span v-else class="text-caption text-grey">-</span>
                </template>

                <!-- Coluna Status Início -->
                <template #item.status_inicio_nome="{ item }">
                  <v-chip size="small" color="success" variant="tonal">
                    {{ item.status_inicio_nome }}
                  </v-chip>
                </template>

                <!-- Coluna Status Fim -->
                <template #item.status_fim_nome="{ item }">
                  <v-chip v-if="item.status_fim_nome && item.status_fim_nome !== 'N/A'" 
                          size="small" color="warning" variant="tonal">
                    {{ item.status_fim_nome }}
                  </v-chip>
                  <span v-else class="text-caption text-grey">-</span>
                </template>

                <!-- Coluna Tempo Formatado -->
                <template #item.tempo_formatado="{ item }">
                  <div class="text-body-2">
                    <strong>{{ item.tempo_formatado }}</strong>
                    <div class="text-caption text-grey">
                      ({{ item.tempo_horas }}h)
                    </div>
                  </div>
                </template>
  
                <!-- Coluna de Status -->
                <template #item.status="{ item }">
                  <v-chip :color="getCorStatus(item.status)" size="small">
                    {{ item.status }}
                    <v-tooltip activator="parent" location="top">
                      {{ getDescricaoStatus(item.status) }}
                    </v-tooltip>
                  </v-chip>
                </template>

                <!-- Coluna de Motivo -->
                <template #item.motivo="{ item }">
                  <div v-if="item.motivo || item.motivo_ajuste" class="motivo-cell">
                    <v-chip 
                      size="small" 
                      color="warning" 
                      variant="tonal"
                      prepend-icon="mdi-alert-circle"
                    >
                      <span class="text-truncate" style="max-width: 150px;">
                        {{ item.motivo || item.motivo_ajuste }}
                      </span>
                      <v-tooltip activator="parent" location="top">
                        <div><strong>Motivo da Alteração:</strong></div>
                        <div class="mt-1">{{ item.motivo || item.motivo_ajuste }}</div>
                      </v-tooltip>
                    </v-chip>
                  </div>
                  <span v-else class="text-caption text-grey">-</span>
                </template>
  
                <!-- Coluna de Ações -->
                <template #item.actions="{ item }">
                  <v-btn color="primary" size="small" variant="text" @click="abrirDialogoAjusteIndividual(item)">
                    <v-icon small>mdi-clock-edit</v-icon>
                    <v-tooltip activator="parent" location="top">Editar horário com cascata</v-tooltip>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
  
      <!-- 📖 Dialog de Ajuda -->
      <v-dialog v-model="mostrarAjuda" max-width="900" scrollable>
        <v-card>
          <v-card-title class="d-flex align-center pa-4 white--text"
                        style="background: linear-gradient(135deg, #FF9800 0%, #FFB74D 100%);">
            <v-icon left color="white" size="32">mdi-help-circle</v-icon>
            <span class="text-h5 font-weight-bold">Como Usar - Alteração de Horários</span>
            <v-spacer></v-spacer>
            <v-btn icon color="white" @click="mostrarAjuda = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-6" style="max-height: 600px;">
            <div class="ajuda-content">
              <h3 class="text-h6 mb-3">🎯 Funcionalidades Principais</h3>
              
              <v-alert type="info" variant="tonal" class="mb-4">
                <strong>Agrupamento Inteligente:</strong> Ative "Agrupar por status" para ver registros organizados por status inicial e final, facilitando alterações em lote!
              </v-alert>

              <h4 class="text-subtitle-1 font-weight-bold mb-2">1️⃣ Filtros Disponíveis</h4>
              <ul class="mb-4">
                <li><strong>ID Abertura:</strong> Filtrar registros de uma abertura específica</li>
                <li><strong>Funcionário:</strong> Selecione um funcionário para ver apenas seus registros</li>
                <li><strong>Status:</strong> Filtrar por status específico (Aberto, Fechado, Encerrado)</li>
                <li><strong>Incluir fechados:</strong> Marque para visualizar registros já fechados</li>
                <li><strong>Agrupar por status:</strong> Organiza registros em grupos por status inicial e final</li>
              </ul>

              <h4 class="text-subtitle-1 font-weight-bold mb-2">2️⃣ Alteração em Lote</h4>
              <v-stepper alt-labels flat class="mb-4">
                <v-stepper-header>
                  <v-stepper-item title="Selecionar" value="1" complete></v-stepper-item>
                  <v-divider></v-divider>
                  <v-stepper-item title="Definir Data" value="2" complete></v-stepper-item>
                  <v-divider></v-divider>
                  <v-stepper-item title="Aplicar" value="3" complete></v-stepper-item>
                </v-stepper-header>
              </v-stepper>
              <ol class="mb-4">
                <li>Marque os checkboxes dos registros que deseja alterar</li>
                <li>Clique em "Selecionar Todos" para marcar todos de uma vez</li>
                <li>Defina uma "Data Padrão de Fechamento" no campo no topo</li>
                <li>Clique em "Fechar Agora" para aplicar a mesma data/hora em todos</li>
              </ol>

              <v-alert type="warning" variant="tonal" class="mb-4">
                <strong>⚠️ Atenção:</strong> Ao alterar registros fechados ou encerrados, o sistema registrará a alteração para auditoria.
              </v-alert>

              <h4 class="text-subtitle-1 font-weight-bold mb-2">3️⃣ Visualização Agrupada</h4>
              <p class="mb-2">Quando ativada, os registros são agrupados mostrando:</p>
              <ul class="mb-4">
                <li><strong>Status Início → Status Fim:</strong> Ex: "Início do expediente → Intervalo lanche"</li>
                <li><strong>Horários:</strong> Abertura e fechamento do grupo</li>
                <li><strong>Total de Funcionários:</strong> Quantos registros neste grupo</li>
                <li><strong>Ações em Grupo:</strong> Selecionar todos do grupo e alterar de uma vez</li>
              </ul>

              <h4 class="text-subtitle-1 font-weight-bold mb-2">4️⃣ Alteração Individual</h4>
              <p class="mb-4">
                Clique no ícone de edição <v-icon size="small" color="primary">mdi-clock-edit</v-icon> 
                em qualquer registro para editá-lo individualmente.
              </p>

              <h4 class="text-subtitle-1 font-weight-bold mb-2">5️⃣ Códigos de Cores</h4>
              <v-row dense class="mb-4">
                <v-col cols="6">
                  <v-chip size="small" color="primary" class="mr-2">ABERTO</v-chip>
                  <span class="text-caption">Pode ser alterado livremente</span>
                </v-col>
                <v-col cols="6">
                  <v-chip size="small" color="warning" class="mr-2">FECHADO</v-chip>
                  <span class="text-caption">Alteração requer justificativa</span>
                </v-col>
                <v-col cols="6">
                  <v-chip size="small" color="success" class="mr-2">ENCERRADO</v-chip>
                  <span class="text-caption">Alteração é auditada</span>
                </v-col>
                <v-col cols="6">
                  <v-chip size="small" color="error" class="mr-2">CANCELADO</v-chip>
                  <span class="text-caption">Não pode ser alterado</span>
                </v-col>
              </v-row>

              <v-alert type="success" variant="tonal">
                <strong>💡 Dica:</strong> Use o filtro de funcionário + agrupamento para facilmente corrigir todos os registros de uma pessoa!
              </v-alert>
            </div>
          </v-card-text>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="elevated" @click="mostrarAjuda = false">
              <v-icon left>mdi-check</v-icon>
              Entendi
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo de Ajuste MELHORADO -->
      <v-dialog v-model="mostrarDialogoAjuste" max-width="900" persistent>
        <v-card class="dialog-ajuste">
          <!-- Header -->
          <v-card-title class="pa-4" style="background: linear-gradient(135deg, #1976D2 0%, #2196F3 100%);">
            <div class="d-flex align-center w-100">
              <v-icon color="white" size="32" class="mr-3">mdi-clock-edit</v-icon>
              <div class="flex-grow-1">
                <div class="text-h6 font-weight-bold text-white">Ajuste de Horário</div>
                <div class="text-caption text-white" style="opacity: 0.9;">
                  {{ registrosSelecionados.length }} funcionário(s) selecionado(s)
                  <span v-if="grupoAtual"> - {{ grupoAtual.status_inicio }} → {{ grupoAtual.status_fim }}</span>
                </div>
              </div>
              <v-btn icon variant="text" @click="fecharDialogoAjuste" size="small">
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>
  
          <v-card-text class="pa-6">
            <!-- Card com informações atuais -->
            <v-card v-if="grupoAtual" variant="tonal" color="blue-grey" class="mb-4">
              <v-card-text class="pa-4">
                <div class="text-subtitle-2 font-weight-bold mb-3">📊 Horários Atuais:</div>
                <v-row dense>
                  <v-col cols="12" md="4">
                    <div class="info-box">
                      <v-icon color="success" size="20" class="mb-1">mdi-clock-start</v-icon>
                      <div class="text-caption text-grey-darken-1">Início</div>
                      <div class="text-h6 font-weight-bold">{{ grupoAtual.horario_abertura }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="info-box">
                      <v-icon color="warning" size="20" class="mb-1">mdi-clock-end</v-icon>
                      <div class="text-caption text-grey-darken-1">Fim</div>
                      <div class="text-h6 font-weight-bold">{{ grupoAtual.horario_fechamento }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="info-box">
                      <v-icon color="primary" size="20" class="mb-1">mdi-timer</v-icon>
                      <div class="text-caption text-grey-darken-1">Duração</div>
                      <div class="text-h6 font-weight-bold">{{ grupoAtual.tempo_total }}</div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-divider class="my-4"></v-divider>

            <!-- Novos Horários -->
            <div class="text-h6 font-weight-bold mb-4">⚙️ Definir Novos Horários:</div>
            <v-row>
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="dataPadraoInicio"
                  label="Novo Horário de Início"
                  type="datetime-local"
                  variant="outlined"
                  color="primary"
                  persistent-hint
                  hint="Deixe em branco para não alterar"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success">mdi-clock-start</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="dataPadraoFechamento"
                  label="Novo Horário de Fechamento"
                  type="datetime-local"
                  variant="outlined"
                  color="primary"
                  persistent-hint
                  hint="Deixe em branco para não alterar"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="warning">mdi-clock-end</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              
              <v-col cols="12" md="2" class="d-flex align-center justify-center">
                <v-card v-if="tempoCalculado" variant="tonal" color="primary" class="text-center pa-3">
                  <v-icon color="primary" size="24">mdi-timer-sand</v-icon>
                  <div class="text-caption mt-1">Novo Tempo</div>
                  <div class="text-h6 font-weight-bold">{{ tempoCalculado }}</div>
                </v-card>
              </v-col>
            </v-row>

            <!-- Opção de atualizar fechamento geral -->
            <v-alert v-if="dataPadraoFechamento" type="warning" variant="tonal" class="mt-4">
              <v-checkbox
                v-model="atualizarFechamentoGeral"
                color="warning"
                hide-details
              >
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon class="mr-2">mdi-calendar-clock</v-icon>
                    <div>
                      <strong>Atualizar encerramento geral da abertura?</strong>
                      <div class="text-caption">
                        Isso alterará o campo data_encerramento da expediente_abertura para {{ dataPadraoFechamento ? new Date(dataPadraoFechamento).toLocaleString('pt-BR') : '' }}
                      </div>
                    </div>
                  </div>
                </template>
              </v-checkbox>
            </v-alert>
          </v-card-text>

          <!-- Footer com botões -->
          <v-divider></v-divider>
          <v-card-actions class="pa-4 bg-grey-lighten-5">
            <v-spacer></v-spacer>
            
            <v-btn
              variant="text"
              size="large"
              @click="fecharDialogoAjuste"
              :disabled="loadingAjuste"
            >
              <v-icon start>mdi-close</v-icon>
              Cancelar
            </v-btn>
            
            <v-btn
              color="primary"
              variant="elevated"
              size="large"
              :disabled="registrosSelecionados.length === 0 || (!dataPadraoInicio && !dataPadraoFechamento) || loadingAjuste"
              :loading="loadingAjuste"
              @click="ajustarTodosComDataPadrao"
            >
              <v-icon start>mdi-check-circle</v-icon>
              Confirmar Ajuste ({{ registrosSelecionados.length }})
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  
  <script>
  import { ref, reactive, computed, onMounted } from 'vue'
  import { expedienteAlteracaoHorarioManualService } from "@/services/expedienteAlteracaoHorarioManualService"
  import { useToast } from "vue-toastification"
  import { useRouter } from 'vue-router'
  
  export default {
    name: "ExpedienteAlteracaoHorarioManual",
  
    setup() {
      const router = useRouter()
      const toast = useToast()
  
      // Estados
      const loadingBusca = ref(false)
      const loadingAjuste = ref(false)
      const loadingStatus = ref(false)
      const mostrarDialogoAjuste = ref(false)
      const mostrarAjuda = ref(false) // Dialog de ajuda
      
      // Dados
      const registros = ref([])
      const registrosSelecionados = ref([])
      const statusDisponiveis = ref([])
      const totais = ref({})
      const dataPadraoInicio = ref('')
      const dataPadraoFechamento = ref('')
      const grupoAtual = ref(null) // Grupo sendo editado no dialog
      const atualizarFechamentoGeral = ref(false) // Atualizar data de fechamento da abertura
  
      // Filtros
      const filtros = reactive({
        id_abertura: null,
        id_funcionario: null,
        status: null,
        incluirFechados: false,
        agruparPorStatus: true // Agrupamento por status
      })
  
      // Dados do ajuste
      const dadosAjuste = ref({
        novo_horario_inicio: '',
        novo_horario_fim: '',
        motivo: ''
      }) 
  
      // Configuração da tabela
      const headers = [
        { title: "ID", key: "id", sortable: true, width: "70px" },
        { title: "Abertura", key: "id_abertura", sortable: true, width: "90px" },
        { title: "Lote", key: "lote_processamento", sortable: true, width: "100px" },
        { title: "Funcionário", key: "funcionario_nome", sortable: true, width: "150px" },
        { title: "Setor", key: "setor_nome", sortable: true, width: "120px" },
        { title: "Ordem", key: "ordem_numero", sortable: true, width: "90px" },
        { title: "Status Início", key: "status_inicio_nome", sortable: true, width: "120px" },
        { title: "Status Fim", key: "status_fim_nome", sortable: true, width: "120px" },
        { title: "Início", key: "inicio_formatado", sortable: true, width: "130px" },
        { title: "Fim", key: "fim_formatado", sortable: true, width: "130px" },
        { title: "Tempo", key: "tempo_formatado", sortable: true, width: "90px" },
        { title: "Status", key: "status", sortable: true, width: "90px" },
        { title: "Motivo", key: "motivo", sortable: true, width: "200px" },
        { title: "Ações", key: "actions", sortable: false, width: "80px" }
      ]
  
      // Computed
      const registrosFechadosSelecionados = computed(() => {
        return registrosSelecionados.value.filter(r => 
          ['fechado', 'encerrado'].includes(r.status.toLowerCase())
        ).length
      })

      // ⏱️ Calcular tempo automaticamente
      const tempoCalculado = computed(() => {
        if (!dataPadraoInicio.value || !dataPadraoFechamento.value) {
          return null
        }

        try {
          const inicio = new Date(dataPadraoInicio.value)
          const fim = new Date(dataPadraoFechamento.value)
          
          if (isNaN(inicio.getTime()) || isNaN(fim.getTime())) {
            return null
          }

          const diffMs = fim - inicio
          
          if (diffMs < 0) {
            return '⚠️ Inválido'
          }

          const diffSecs = Math.floor(diffMs / 1000)
          const hours = Math.floor(diffSecs / 3600)
          const minutes = Math.floor((diffSecs % 3600) / 60)
          
          return `${hours}h ${minutes.toString().padStart(2, '0')}min`
        } catch (error) {
          return null
        }
      })

      const alertType = computed(() => {
        return registrosFechadosSelecionados.value > 0 ? 'warning' : 'info'
      })

      const alertTitle = computed(() => {
        return registrosSelecionados.value.length > 1 ? 
          `${registrosSelecionados.value.length} Registros Selecionados` : 
          '1 Registro Selecionado'
      })

      const alertMessage = computed(() => {
        const fechados = registrosFechadosSelecionados.value
        const abertos = registrosSelecionados.value.length - fechados
        
        let msg = []
        if (abertos > 0) msg.push(`${abertos} em aberto`)
        if (fechados > 0) msg.push(`${fechados} fechados`)
        
        return msg.join(' | ')
      })

      // ✨ Funcionários únicos para autocomplete
      const funcionariosUnicos = computed(() => {
        const funcionariosMap = new Map()
        
        registros.value.forEach(reg => {
          if (reg.id_funcionario && reg.funcionario_nome) {
            funcionariosMap.set(reg.id_funcionario, {
              id: reg.id_funcionario,
              nome: reg.funcionario_nome
            })
          }
        })
        
        return Array.from(funcionariosMap.values()).sort((a, b) => 
          a.nome.localeCompare(b.nome)
        )
      })

      // ✨ Registros agrupados por status inicial e final
      const registrosAgrupados = computed(() => {
        if (!filtros.agruparPorStatus) {
          return []
        }

        const grupos = {}
        
        registros.value.forEach(reg => {
          const chave = `${reg.status_inicio_nome || 'N/A'}_${reg.status_fim_nome || 'N/A'}`
          
          if (!grupos[chave]) {
            grupos[chave] = {
              status_inicio: reg.status_inicio_nome || 'N/A',
              status_fim: reg.status_fim_nome || 'N/A',
              registros: [],
              horario_abertura: reg.inicio_formatado,
              horario_fechamento: reg.fim_formatado,
              horario_abertura_raw: reg.inicio, // Para ordenação
              horario_fechamento_raw: reg.fim, // Para ordenação por fim
              tempo_formatado: reg.tempo_formatado,
              tempo_total: reg.tempo_formatado || 'N/A',
              id_minimo: reg.id, // Para ordenação
              total: 0,
              total_com_motivo: 0 // Contador de registros com motivo
            }
          }
          
          // Atualiza ID mínimo para ordenação e horários do primeiro registro
          if (reg.id < grupos[chave].id_minimo) {
            grupos[chave].id_minimo = reg.id
            grupos[chave].horario_abertura = reg.inicio_formatado
            grupos[chave].horario_fechamento = reg.fim_formatado
            grupos[chave].horario_abertura_raw = reg.inicio
            grupos[chave].horario_fechamento_raw = reg.fim
            grupos[chave].tempo_total = reg.tempo_formatado
          }
          
          grupos[chave].registros.push(reg)
          grupos[chave].total++
          
          // Contar registros com motivo (motivo OU motivo_ajuste)
          if (reg.motivo || reg.motivo_ajuste) {
            grupos[chave].total_com_motivo = (grupos[chave].total_com_motivo || 0) + 1
          }
        })
        
        // Ordenar grupos cronologicamente
        const gruposOrdenados = Object.values(grupos).sort((a, b) => {
          // 1ª prioridade: Horário de início (mais cedo primeiro)
          const inicioA = new Date(a.horario_abertura_raw).getTime()
          const inicioB = new Date(b.horario_abertura_raw).getTime()
          
          if (inicioA !== inicioB) {
            return inicioA - inicioB
          }
          
          // 2ª prioridade: Horário de término (termina primeiro = aparece antes)
          const fimA = a.horario_fechamento_raw ? new Date(a.horario_fechamento_raw).getTime() : Infinity
          const fimB = b.horario_fechamento_raw ? new Date(b.horario_fechamento_raw).getTime() : Infinity
          
          if (fimA !== fimB) {
            return fimA - fimB
          }
          
          // 3ª prioridade: ID (fallback)
          return a.id_minimo - b.id_minimo
        })
        
        // 🐛 DEBUG: Mostrar ordenação
        console.log('📅 ORDENAÇÃO DA TIMELINE:')
        gruposOrdenados.forEach((grupo, index) => {
          console.log(`${index + 1}. ${grupo.horario_abertura} → ${grupo.horario_fechamento}`)
          console.log(`   ${grupo.status_inicio} → ${grupo.status_fim}`)
          console.log(`   ⏱️ ${grupo.tempo_total} | 👥 ${grupo.total} funcionários`)
        })
        
        // 🐛 DEBUG: Verificar motivos nos grupos
        const comMotivo = gruposOrdenados.filter(g => g.total_com_motivo > 0)
        if (comMotivo.length > 0) {
          console.log(`\n⚠️ ${comMotivo.length} grupo(s) com motivo`)
        }
        
        return gruposOrdenados
      })
  
      // Métodos
      const carregarStatusDisponiveis = async () => {
        loadingStatus.value = true
        try {
          const response = await expedienteAlteracaoHorarioManualService.buscarStatusDisponiveis()
          if (response.success) {
            statusDisponiveis.value = response.status
          }
        } catch (error) {
          console.error("Erro ao carregar status:", error)
          toast.error("Erro ao carregar status disponíveis")
        } finally {
          loadingStatus.value = false
        }
      }
  
      const buscarRegistros = async () => {
        loadingBusca.value = true
        registros.value = []
        totais.value = {}
        
        try {
          // Converter filtros para o formato esperado pelo serviço
          const params = {
            id_abertura: filtros.id_abertura || undefined,
            id_funcionario: filtros.id_funcionario || undefined,
            status: filtros.status || undefined,
            incluir_fechados: filtros.incluirFechados || undefined
          }
  
          const response = await expedienteAlteracaoHorarioManualService.buscarRegistros(params)
          
          if (response.success) {
            registros.value = response.registros.map(reg => ({
              ...reg,
              funcionario_nome: reg.funcionario?.nome || 'N/A',
              setor_nome: reg.setor?.nome || 'N/A',
              dias: calcularDiasEmAberto(reg.inicio, reg.fim),
              // ✅ Garantir que motivo seja preservado
              motivo: reg.motivo || null,
              motivo_ajuste: reg.motivo_ajuste || null
            }))
            totais.value = response.totais
            
            // 🐛 DEBUG: Verificar registros com motivo
            const comMotivo = registros.value.filter(r => r.motivo || r.motivo_ajuste)
            console.log('📊 Total de registros:', registros.value.length)
            console.log('⚠️ Registros COM motivo:', comMotivo.length)
            if (comMotivo.length > 0) {
              console.log('📝 Primeiros 3 registros com motivo:', comMotivo.slice(0, 3).map(r => ({
                id: r.id,
                funcionario: r.funcionario_nome,
                motivo: r.motivo,
                motivo_ajuste: r.motivo_ajuste
              })))
            }
          } else {
            toast.warning(response.message || "Nenhum registro encontrado com os filtros aplicados")
          }
        } catch (error) {
          console.error("Erro ao buscar registros:", error)
          toast.error("Erro ao buscar registros")
        } finally {
          loadingBusca.value = false
        }
      }
  
      const abrirDialogoAjuste = () => {
        if (registrosSelecionados.value.length === 0) {
          toast.warning("Selecione pelo menos um registro")
          return
        }
        
        // Configura dados para o diálogo
        dadosAjuste.registros = [...registrosSelecionados.value]
        
        if (registrosSelecionados.value.length === 1) {
          const registro = registrosSelecionados.value[0]
          dadosAjuste.data_original = formatarDataHora(registro.inicio)
          if (registro.fim) {
            dadosAjuste.data_original += `\nFim: ${formatarDataHora(registro.fim)}`
          }
        } else {
          dadosAjuste.data_original = `${registrosSelecionados.value.length} registros selecionados`
        }
        
        // Define horário padrão como agora
        const agora = new Date()
        dadosAjuste.novo_horario = agora.toISOString().slice(0, 16)
        dadosAjuste.motivo = ""
        
        mostrarDialogoAjuste.value = true
      }
  
      const abrirDialogoAjusteIndividual = (registro) => {
        registrosSelecionados.value = [registro]
        abrirDialogoAjuste()
      }
  
      const fecharDialogoAjuste = () => {
        mostrarDialogoAjuste.value = false
        dadosAjuste.registros = []
        grupoAtual.value = null // Limpa informações do grupo
        dataPadraoInicio.value = ''
        dataPadraoFechamento.value = ''
        atualizarFechamentoGeral.value = false // Reset flag
      }
  
      const aplicarAjuste = async () => {
        if ((!dadosAjuste.novo_horario_inicio && !dadosAjuste.novo_horario_fim) || !dadosAjuste.motivo) {
          toast.warning("Preencha pelo menos uma data (início ou fim) e o motivo")
          return
        }
  
        loadingAjuste.value = true
        try {
          console.log('Registros selecionados (ajuste):', registrosSelecionados.value)
          
          const idsRegistros = registrosSelecionados.value
            .map(r => r?.id || r)
            .filter(id => id != null && id !== undefined && id !== '')
          
          console.log('IDs extraídos (ajuste):', idsRegistros)
          
          if (idsRegistros.length === 0) {
            toast.warning("Nenhum ID válido encontrado nos registros selecionados")
            return
          }
          
          const dadosEnvio = {
            ids_registros: idsRegistros,
            motivo: dadosAjuste.motivo,
            usuario: "Usuário Atual" // Substituir por dados reais do usuário
          }
          
          if (dadosAjuste.novo_horario_inicio) {
            dadosEnvio.novo_horario_inicio = new Date(dadosAjuste.novo_horario_inicio).toISOString()
          }
          
          if (dadosAjuste.novo_horario_fim) {
            dadosEnvio.novo_horario_fim = new Date(dadosAjuste.novo_horario_fim).toISOString()
          }
          
          const response = await expedienteAlteracaoHorarioManualService.ajustarHorarios(dadosEnvio)
  
          if (response.success) {
            toast.success(response.message)
            await buscarRegistros()
            fecharDialogoAjuste()
            
            // Log de sucesso
            console.log("Ajuste realizado com sucesso. Log ID:", response.logId)
          } else {
            toast.error(response.message || "Erro ao aplicar ajuste")
          }
        } catch (error) {
          console.error("Erro ao aplicar ajuste:", error)
          toast.error("Erro ao aplicar ajuste. Tente novamente.")
        } finally {
          loadingAjuste.value = false
        }
      }
  
      // ❌ MÉTODOS REMOVIDOS - Botões do cabeçalho não são mais usados
      // Ajuste agora é feito apenas por grupos na timeline
      // const selecionarTodosRegistros = () => {
      //   registrosSelecionados.value = [...registros.value]
      // }
  
      const limparSelecoes = () => {
        registrosSelecionados.value = []
      }

      const ajustarTodosComDataPadrao = async (forcarSalvar = false) => {
        if (!dataPadraoInicio.value && !dataPadraoFechamento.value) {
          toast.warning("Defina pelo menos uma data (início ou fechamento)")
          return
        }

        if (registrosSelecionados.value.length === 0) {
          toast.warning("Selecione pelo menos um registro")
          return
        }

        // 🛡️ Validar conflitos se estiver alterando horário de fechamento
        if (dataPadraoFechamento.value && !forcarSalvar) {
          const dataFormatada = new Date(dataPadraoFechamento.value).toISOString()
          const validacao = validarConflitoHorarios(dataFormatada)
          
          if (!validacao.valido) {
            await mostrarDialogoConflitoDetalhado(validacao)
            return
          }
        }

        loadingAjuste.value = true
        try {
          console.log('Registros selecionados:', registrosSelecionados.value)
          
          const idsRegistros = registrosSelecionados.value
            .map(r => r?.id || r)
            .filter(id => id != null && id !== undefined && id !== '')
          
          console.log('IDs extraídos:', idsRegistros)
          
          if (idsRegistros.length === 0) {
            toast.warning("Nenhum ID válido encontrado nos registros selecionados")
            return
          }
          
          const dadosEnvio = {
            ids_registros: idsRegistros,
            motivo: "Ajuste em lote com datas padrão",
            usuario: "Usuário Atual",
            atualizar_fechamento_geral: atualizarFechamentoGeral.value
          }
          
          console.log('☑️ Checkbox atualizar encerramento:', atualizarFechamentoGeral.value)
          
          if (atualizarFechamentoGeral.value) {
            console.warn('⚠️ ATENÇÃO: Checkbox MARCADO - Deve atualizar data_encerramento da abertura!')
          } else {
            console.info('ℹ️ Checkbox DESMARCADO - NÃO vai atualizar abertura')
          }
          
          // ✅ Enviar horário LOCAL sem conversão UTC
          if (dataPadraoInicio.value) {
            // Formato: "2025-10-17T17:00" → "2025-10-17 17:00:00"
            dadosEnvio.novo_horario_inicio = dataPadraoInicio.value.replace('T', ' ') + ':00'
            console.log('🕐 Horário início digitado:', dataPadraoInicio.value, '→ Enviando:', dadosEnvio.novo_horario_inicio)
          }
          
          if (dataPadraoFechamento.value) {
            // Formato: "2025-10-17T19:00" → "2025-10-17 19:00:00"
            dadosEnvio.novo_horario_fim = dataPadraoFechamento.value.replace('T', ' ') + ':00'
            console.log('🕐 Horário fim digitado:', dataPadraoFechamento.value, '→ Enviando:', dadosEnvio.novo_horario_fim)
          }
          
          console.log('📦 Dados completos sendo enviados:', dadosEnvio)
          
          const response = await expedienteAlteracaoHorarioManualService.ajustarHorarios(dadosEnvio)

          console.log('✅ Resposta recebida do backend:', response)

          if (response.success) {
            // Backend envia message já formatada se atualizou abertura
            const mensagem = response.aberturaAtualizada 
              ? response.message 
              : `${response.registrosAfetados || 0} registro(s) ajustado(s) com sucesso`
            
            console.log('📢 Mensagem que será exibida:', mensagem)
            toast.success(mensagem, { timeout: 5000 })
            
            // Fechar dialog ANTES de limpar
            fecharDialogoAjuste()
            
            // Aguardar um pouco antes de recarregar
            await new Promise(resolve => setTimeout(resolve, 300))
            await buscarRegistros()
            limparSelecoes()
          } else {
            // Mostrar detalhes específicos do erro de validação
            if (response.validationErrors) {
              const errorMessages = Object.values(response.validationErrors).flat()
              toast.error(`Erro de validação: ${errorMessages.join(', ')}`)
            } else {
              toast.error(response.message || "Erro ao ajustar registros")
            }
          }
        } catch (error) {
          console.error('Erro ao ajustar registros:', error)
          toast.error("Erro inesperado ao ajustar registros")
        } finally {
          loadingAjuste.value = false
        }
      }
  
      // ❌ MÉTODO REMOVIDO - Botão "Fechar Agora" não é mais usado
      // const fecharTodosComDataPadrao = async () => {
      //   if (!dataPadraoFechamento.value) {
      //     toast.warning("Defina uma data padrão de fechamento")
      //     return
      //   }
      //
      //   if (registrosSelecionados.value.length === 0) {
      //     toast.warning("Selecione pelo menos um registro")
      //     return
      //   }
      //
      //   loadingAjuste.value = true
      //   try {
      //     await ajustarTodosComDataPadrao()
      //   } finally {
      //     loadingAjuste.value = false
      //   }
      // }

      // ❌ MÉTODO DUPLICADO REMOVIDO - já comentado acima
      // const fecharTodosComDataPadrao = async () => { ... }
  
      // Utilitários
      const calcularDiasEmAberto = (inicio, fim = null) => {
        if (!inicio) return 0
        const dataFim = fim ? new Date(fim) : new Date()
        const diff = dataFim - new Date(inicio)
        return Math.floor(diff / (1000 * 60 * 60 * 24))
      }
  
      const formatarDataHora = (data) => {
        if (!data) return "N/A"
        return new Date(data).toLocaleString('pt-BR')
      }
  
      const getCorStatus = (status) => {
        const statusLower = status?.toLowerCase() || ''
        switch(statusLower) {
          case 'aberto': return 'primary'
          case 'fechado': return 'warning'
          case 'encerrado': return 'success'
          case 'cancelado': return 'error'
          default: return 'secondary'
        }
      }
  
      const getDescricaoStatus = (status) => {
        const statusLower = status?.toLowerCase() || ''
        switch(statusLower) {
          case 'aberto': return 'Registro em aberto - pode ser alterado'
          case 'fechado': return 'Registro fechado - alteração requer justificativa'
          case 'encerrado': return 'Registro encerrado - alteração auditada'
          case 'cancelado': return 'Registro cancelado - não pode ser alterado'
          default: return 'Status desconhecido'
        }
      }
  
      const getCorDias = (dias) => {
        if (dias < 1) return 'green'
        if (dias < 3) return 'orange'
        return 'red'
      }
  
      const voltarMenu = () => {
        router.push({ name: "MenuDefault" })
      }

      // 🎯 Métodos para agrupamento por status
      const selecionarGrupo = (grupo) => {
        // Adiciona todos os registros do grupo à seleção
        grupo.registros.forEach(reg => {
          if (!registrosSelecionados.value.includes(reg)) {
            registrosSelecionados.value.push(reg)
          }
        })
        toast.success(`${grupo.total} registro(s) selecionado(s) do grupo`)
      }

      const alterarGrupo = (grupo) => {
        // Filtra apenas os registros selecionados do grupo
        const selecionadosDoGrupo = grupo.registros.filter(reg =>
          registrosSelecionados.value.includes(reg)
        )
        
        if (selecionadosDoGrupo.length === 0) {
          toast.warning("Selecione pelo menos um registro do grupo")
          return
        }
        
        // Define o grupo atual para mostrar informações no dialog
        grupoAtual.value = {
          status_inicio: grupo.status_inicio,
          status_fim: grupo.status_fim,
          total: selecionadosDoGrupo.length, // Total de SELECIONADOS
          horario_abertura: grupo.horario_abertura,
          horario_fechamento: grupo.horario_fechamento,
          tempo_total: grupo.tempo_total
        }
        
        // ✅ NÃO pré-preenche os campos - usuário define novos horários
        dataPadraoInicio.value = ''
        dataPadraoFechamento.value = ''
        
        // Abre dialog de ajuste
        mostrarDialogoAjuste.value = true
      }

      const verificarGrupoSelecionado = (grupo) => {
        return grupo.registros.some(reg => 
          registrosSelecionados.value.includes(reg)
        )
      }

      const contarSelecionadosGrupo = (grupo) => {
        return grupo.registros.filter(reg =>
          registrosSelecionados.value.includes(reg)
        ).length
      }

      const toggleRegistro = (registro) => {
        const index = registrosSelecionados.value.findIndex(r => r.id === registro.id)
        if (index > -1) {
          registrosSelecionados.value.splice(index, 1)
        } else {
          registrosSelecionados.value.push(registro)
        }
      }

      // 🛡️ Validação de conflito de horários com mensagens detalhadas
      const validarConflitoHorarios = (novoHorarioFim) => {
        if (!novoHorarioFim) return { valido: true, conflitos: [] }

        const conflitos = []
        const novoFim = new Date(novoHorarioFim)

        // Agrupar registros selecionados por funcionário
        const porFuncionario = {}
        registrosSelecionados.value.forEach(reg => {
          if (!porFuncionario[reg.id_funcionario]) {
            porFuncionario[reg.id_funcionario] = []
          }
          porFuncionario[reg.id_funcionario].push(reg)
        })

        // Para cada funcionário, verificar se há registros posteriores
        Object.keys(porFuncionario).forEach(idFunc => {
          const regsDoFunc = porFuncionario[idFunc]
          
          regsDoFunc.forEach(regSelecionado => {
            // Buscar próximo registro do mesmo funcionário
            const proximosRegs = registros.value.filter(r => 
              r.id_funcionario === parseInt(idFunc) && 
              r.id > regSelecionado.id &&
              r.inicio
            ).sort((a, b) => a.id - b.id)

            if (proximosRegs.length > 0) {
              const proximoReg = proximosRegs[0]
              const proximoInicio = new Date(proximoReg.inicio)
              const fimAtual = new Date(regSelecionado.fim || regSelecionado.inicio)

              // Se o novo horário de fim for maior que o próximo início, há conflito
              if (novoFim > proximoInicio) {
                // Calcular diferença em minutos
                const diferencaMs = novoFim - proximoInicio
                const diferencaMinutos = Math.floor(diferencaMs / (1000 * 60))
                const horas = Math.floor(diferencaMinutos / 60)
                const minutos = diferencaMinutos % 60
                const diferencaTexto = horas > 0 
                  ? `${horas}h ${minutos}min` 
                  : `${minutos} minutos`

                conflitos.push({
                  funcionario: regSelecionado.funcionario_nome,
                  idFuncionario: regSelecionado.id_funcionario,
                  registroAtual: regSelecionado.id,
                  proximoRegistro: proximoReg.id,
                  statusAtual: `${regSelecionado.status_inicio_nome || 'N/A'} → ${regSelecionado.status_fim_nome || 'N/A'}`,
                  proximoStatus: `${proximoReg.status_inicio_nome || 'N/A'} → ${proximoReg.status_fim_nome || 'N/A'}`,
                  fimAtual: fimAtual.toLocaleString('pt-BR'),
                  novoFim: novoFim.toLocaleString('pt-BR'),
                  proximoInicio: proximoInicio.toLocaleString('pt-BR'),
                  diferenca: diferencaTexto,
                  ordem: proximoReg.ordem_numero || 'N/A'
                })
              }
            }
          })
        })

        return {
          valido: conflitos.length === 0,
          conflitos
        }
      }

      // 📋 Mostrar diálogo de conflito detalhado com opção de forçar salvamento
      const mostrarDialogoConflitoDetalhado = async (validacao) => {
        const conflitos = validacao.conflitos
        const funcionariosAfetados = [...new Set(conflitos.map(c => c.funcionario))]
        
        let mensagemHTML = `
          <div style="text-align: left;">
            <p style="font-weight: bold; color: #f44336; font-size: 16px; margin-bottom: 12px;">
              ⚠️ ${conflitos.length} CONFLITO(S) DE HORÁRIO DETECTADO(S)
            </p>
            <p style="margin-bottom: 16px; color: #666;">
              <strong>${funcionariosAfetados.length} funcionário(s) afetado(s):</strong> ${funcionariosAfetados.join(', ')}
            </p>
        `

        conflitos.forEach((conf, index) => {
          mensagemHTML += `
            <div style="background: #fff3e0; padding: 12px; margin-bottom: 12px; border-radius: 8px; border-left: 4px solid #ff9800;">
              <p style="font-weight: bold; margin-bottom: 8px;">
                ${index + 1}. ${conf.funcionario} (ID: ${conf.idFuncionario})
              </p>
              <table style="width: 100%; font-size: 13px; color: #333;">
                <tr>
                  <td style="padding: 4px 8px; width: 40%;"><strong>📋 Registro atual:</strong></td>
                  <td style="padding: 4px 8px;">#${conf.registroAtual}</td>
                </tr>
                <tr>
                  <td style="padding: 4px 8px;"><strong>📌 Status atual:</strong></td>
                  <td style="padding: 4px 8px;">${conf.statusAtual}</td>
                </tr>
                <tr style="background: #ffebee;">
                  <td style="padding: 4px 8px;"><strong>🕐 Fim atual:</strong></td>
                  <td style="padding: 4px 8px;">${conf.fimAtual}</td>
                </tr>
                <tr style="background: #ffebee;">
                  <td style="padding: 4px 8px;"><strong>🕐 Novo fim (pretendido):</strong></td>
                  <td style="padding: 4px 8px; color: #d32f2f; font-weight: bold;">${conf.novoFim}</td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 8px 8px 4px 8px; border-top: 1px dashed #ccc;">
                    <strong>❌ PROBLEMA DETECTADO:</strong>
                  </td>
                </tr>
                <tr style="background: #e3f2fd;">
                  <td style="padding: 4px 8px;"><strong>📋 Próximo registro:</strong></td>
                  <td style="padding: 4px 8px;">#${conf.proximoRegistro} ${conf.ordem !== 'N/A' ? `(Ordem: ${conf.ordem})` : ''}</td>
                </tr>
                <tr style="background: #e3f2fd;">
                  <td style="padding: 4px 8px;"><strong>📌 Próximo status:</strong></td>
                  <td style="padding: 4px 8px;">${conf.proximoStatus}</td>
                </tr>
                <tr style="background: #e3f2fd;">
                  <td style="padding: 4px 8px;"><strong>🕐 Próximo início:</strong></td>
                  <td style="padding: 4px 8px; color: #1976d2; font-weight: bold;">${conf.proximoInicio}</td>
                </tr>
                <tr style="background: #ffebee;">
                  <td style="padding: 4px 8px;"><strong>⏰ Conflito:</strong></td>
                  <td style="padding: 4px 8px; color: #d32f2f; font-weight: bold;">
                    O novo fim está ${conf.diferenca} após o próximo início!
                  </td>
                </tr>
              </table>
              <div style="margin-top: 8px; padding: 8px; background: #fff; border-radius: 4px; font-size: 12px; color: #666;">
                💡 <strong>Explicação:</strong> Você está tentando definir o horário de fechamento como <strong>${conf.novoFim}</strong>, 
                mas este funcionário já possui um próximo registro que inicia às <strong>${conf.proximoInicio}</strong>. 
                Isso criaria uma sobreposição de horários impossível.
              </div>
            </div>
          `
        })

        mensagemHTML += `
            <div style="background: #e8f5e9; padding: 12px; margin-top: 16px; border-radius: 8px; border-left: 4px solid #4caf50;">
              <p style="font-weight: bold; margin-bottom: 8px;">✅ SOLUÇÕES RECOMENDADAS:</p>
              <ul style="margin: 0; padding-left: 20px; font-size: 13px;">
                <li style="margin-bottom: 6px;">Ajuste o horário de fechamento para antes do próximo início</li>
                <li style="margin-bottom: 6px;">Ou ajuste também os próximos registros destes funcionários</li>
                <li style="margin-bottom: 6px;">Ou force o salvamento se você vai corrigir manualmente depois</li>
              </ul>
            </div>
            <div style="background: #fff3e0; padding: 12px; margin-top: 12px; border-radius: 8px; text-align: center;">
              <p style="font-weight: bold; margin-bottom: 8px;">⚠️ DESEJA SALVAR MESMO ASSIM?</p>
              <p style="font-size: 13px; color: #666; margin: 0;">
                Você pode forçar o salvamento e corrigir os choques manualmente depois.
              </p>
            </div>
          </div>
        `

        // Usar confirm nativo ou Swal se disponível
        const confirmar = window.confirm(
          `⚠️ CONFLITOS DE HORÁRIO DETECTADOS\n\n` +
          `${conflitos.length} conflito(s) encontrado(s) em ${funcionariosAfetados.length} funcionário(s):\n` +
          conflitos.map((c, i) => 
            `\n${i + 1}. ${c.funcionario}:\n` +
            `   • Novo fechamento: ${c.novoFim}\n` +
            `   • Próximo início: ${c.proximoInicio}\n` +
            `   • Problema: Fim está ${c.diferenca} APÓS o próximo início\n` +
            `   • Registro atual: #${c.registroAtual} (${c.statusAtual})\n` +
            `   • Próximo registro: #${c.proximoRegistro} (${c.proximoStatus})\n`
          ).join('') +
          `\n\n💡 O horário de fechamento não pode ser posterior ao próximo registro!\n\n` +
          `⚠️ DESEJA SALVAR MESMO ASSIM?\n` +
          `Você poderá corrigir os conflitos manualmente depois.\n\n` +
          `Clique OK para FORÇAR o salvamento ou Cancelar para ajustar os horários.`
        )

        if (confirmar) {
          toast.info('Salvando com conflitos... Lembre-se de corrigir manualmente!', { timeout: 5000 })
          await ajustarTodosComDataPadrao(true) // Forçar salvamento
        } else {
          toast.warning('Operação cancelada. Ajuste os horários e tente novamente.', { timeout: 5000 })
        }
      }
  
      // Lifecycle
      onMounted(() => {
        carregarStatusDisponiveis()
        
        // Definir data padrão como agora
        const agora = new Date()
        dataPadraoFechamento.value = agora.toISOString().slice(0, 16)
      })
  
      return {
        // Estados
        loadingBusca,
        loadingAjuste,
        loadingStatus,
        mostrarDialogoAjuste,
        mostrarAjuda,
        registros,
        registrosSelecionados,
        statusDisponiveis,
        totais,
        filtros,
        dadosAjuste,
        headers,
        dataPadraoFechamento,
        dataPadraoInicio,
        grupoAtual,
        atualizarFechamentoGeral,
        
        // Computed
        registrosFechadosSelecionados,
        alertType,
        alertTitle,
        alertMessage,
        funcionariosUnicos,
        registrosAgrupados,
        tempoCalculado,
        
        // Métodos
        carregarStatusDisponiveis,
        buscarRegistros,
        abrirDialogoAjuste,
        abrirDialogoAjusteIndividual,
        fecharDialogoAjuste,
        aplicarAjuste,
        // selecionarTodosRegistros, // ❌ Removido
        limparSelecoes,
        // fecharTodosComDataPadrao, // ❌ Removido
        ajustarTodosComDataPadrao,
        mostrarDialogoConflitoDetalhado,
        voltarMenu,
        calcularDiasEmAberto,
        formatarDataHora,
        getCorStatus,
        getDescricaoStatus,
        getCorDias,
        // Métodos de agrupamento
        selecionarGrupo,
        alterarGrupo,
        verificarGrupoSelecionado,
        contarSelecionadosGrupo,
        toggleRegistro,
        validarConflitoHorarios
      }
    }
  }
  </script>
  
  <style scoped>
  .alteracao-horario-manual {
    min-height: 100vh;
    background-color: #f5f5f5;
  }

  /* 📅 Estilos para TIMELINE */
  .timeline-container {
    background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
    border-radius: 8px;
  }

  .timeline-time {
    text-align: right;
    padding-right: 16px;
  }

  .timeline-card {
    transition: all 0.3s ease;
    border-left: 4px solid #2196F3 !important;
  }

  .timeline-card:hover {
    transform: translateX(4px);
    box-shadow: 0 8px 16px rgba(0,0,0,0.15) !important;
  }

  /* Cores dos dots da timeline */
  .v-timeline-item:first-child .v-timeline-divider__dot {
    box-shadow: 0 0 0 4px rgba(76, 175, 80, 0.2);
  }

  .v-timeline-item:last-child .v-timeline-divider__dot {
    box-shadow: 0 0 0 4px rgba(244, 67, 54, 0.2);
  }

  /* 📝 Estilos para motivo */
  .registro-com-motivo {
    background-color: #fff9e6 !important;
  }

  .motivo-cell .v-chip {
    max-width: 100%;
  }

  .motivo-cell .text-truncate {
    display: inline-block;
    vertical-align: middle;
  }

  /* 📝 Destaque de motivo nos cards */
  .motivo-destaque {
    font-size: 0.875rem;
    line-height: 1.4;
  }

  .motivo-destaque strong {
    font-size: 0.8125rem;
  }

  .motivo-destaque span {
    word-break: break-word;
  }

  /* 🎨 Dialog de ajuste melhorado */
  .dialog-ajuste {
    border-radius: 12px !important;
    overflow: hidden;
  }

  .info-box {
    text-align: center;
    padding: 8px;
  }

  .info-box .v-icon {
    display: block;
    margin: 0 auto;
  }

  .info-box .text-caption {
    text-transform: uppercase;
    font-size: 0.7rem;
    letter-spacing: 0.5px;
  }

  .ajuda-content h3,
  .ajuda-content h4 {
    color: #1976D2;
  }

  .ajuda-content ul {
    padding-left: 20px;
    line-height: 1.8;
  }

  .ajuda-content ul li {
    margin-bottom: 8px;
  }

  .ajuda-content ol {
    padding-left: 20px;
    line-height: 1.8;
  }

  .ajuda-content ol li {
    margin-bottom: 8px;
  }
  
  /* Ajustes responsivos */
  @media (max-width: 768px) {
    .v-card-title {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .v-card-title .v-spacer {
      display: none;
    }
    
    .v-btn {
      margin-bottom: 8px;
      width: 100%;
    }

    .grupos-container {
      padding: 8px;
    }
  }
  </style>